import cn from 'classnames';
import React, { useCallback } from 'react';
import { ID, l } from 'app/blocks/common/codes';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import middleware from 'app/blocks/middleware/static';
import StaticContent from 'app/blocks/static-content/static-content';

import './resources.scss';
import Dropdown from './dropdown';

type ResourcesProps = {
    onHide: () => void;
    onClick: () => void;
    isOpen: boolean;
};

const TABS = ['menu_resources__authors.html', 'menu_resources__reviewers.html', 'menu_resources__other.html'];

TABS.forEach(src => middleware.getHtml(src));

const ResourcesMenu: React.FC<ResourcesProps> = ({ isOpen, onClick, onHide }) => {
    const onKeyDown = useCallback(
        e => {
            if (e?.code === 'Escape') {
                onHide();
            }
        },
        [onHide],
    );
    return (
        <div className="menu-resources ignore-react-onclickoutside">
            <button
                aria-controls="resources-dropdown-menu"
                aria-expanded={isOpen}
                aria-haspopup="true"
                className={cn('menu-item menu-resourcesButton', { expanded: isOpen })}
                data-seleniumid="menu-resources"
                id="menu_resources_button"
                onClick={onClick}
                onKeyDown={onKeyDown}
                role="menuitem"
                type="button"
            >
                <span className="dropdown-label">{l(`${ID.BUTTONS}.TOP_MENU.RESOURCES`)}</span>
                <SvgIcon.chevron
                    className={cn('menu-icon', { swapped: isOpen })}
                    iconDescr="Arrow up"
                    // iconTitle={l(`${ID.BUTTONS}.TOP_MENU.RESOURCES_ARIA_LABEL`)}
                />
            </button>

            {isOpen && (
                <Dropdown onClickOutside={onHide} seleniumId="resources-dropdown">
                    <div
                        aria-haspopup="menu"
                        aria-owns="menu_resources_button"
                        className="container-lg menu-resources-dropdown"
                        id="resources-dropdown-menu"
                    >
                        {TABS.map(src => (
                            <div className="menu-resources-column" role="group">
                                <StaticContent hideLoadingText src={src} />
                            </div>
                        ))}
                    </div>
                </Dropdown>
            )}
        </div>
    );
};

export default ResourcesMenu;
